/* eslint-disable max-len */
import { FunctionComponent as F, useState } from 'react';
import { Route, Routes, Link as RouterLink } from 'react-router-dom';
import { WHY, WHO, PLANS } from '../../core/router/paths';
import Why from './Why';
import Who from './Who';
import Plans from './Plans';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import PageHeadline from '../../components/UI/Text/PageHeadline';

const About: F = () =>
{
  const articles = [
    {
      title: "Why Protoplan?",
      path: WHY
    },
    {
      title: "Who is behind Protoplan?",
      path: WHO
    },
    {
      title: "What's planned?",
      path: PLANS
    } ];


  const [selected, setSelected] = useState(articles[0].title);

  const articleLink = (article: { title: string, path: string }) => (
    <Link
      variant='subtitle2'
      sx={{ color: 'rgb(0,0,0)' }}
      underline='none'
      component={RouterLink}
      onClick={() => setSelected(article.title)}
      to={article.path}>
      {selected === article.title ? <b>{article.title}</b> : article.title}
    </Link>);

  return (
    <Container>
      <Stack
        justifyContent='center'
        alignItems='center'
        spacing={2}>

        <PageHeadline>About</PageHeadline>

        <Box sx={{ width: 650 }}>
          <Grid container direction='row' sx={{}}>
            <Grid item xs style={{ display: "flex", justifyContent: "flex-start" }}>
              {articleLink(articles[0])}
            </Grid>
            <Grid item xs style={{ display: "flex", justifyContent: "center" }}>
              {articleLink(articles[1])}
            </Grid>
            <Grid item xs style={{ display: "flex", justifyContent: "flex-end" }}>
              {articleLink(articles[2])}
            </Grid>
          </Grid>

          <Box sx={{ height: 50 }}/>

          <Routes>
            <Route path={WHY} element={<Why/>} />
            <Route path={WHO} element={<Who/>} />
            <Route path={PLANS} element={<Plans/>} />
          </Routes>
        </Box>

      </Stack>
    </Container>);
};

export default About;
